import React from 'react';
import PropTypes from 'prop-types';
import styles from '../ArticleComponents.module.css';
import { getStyle } from './Style.js';

import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function ImageComponent({
	component,
	readerMode,
	deviceWidth,
	onImageClick,
	style,
}) {
	let {
		id,
		imageurl,
		align,
		width,
		imagelink,
		captionenabled,
		imageclip,
	} = component;
	let { caption, credit, creditenabled, linktype } = component;

	let imageStyle = {};
	const containerStyle = {
		width: '100%',
		textAlign: align,
	};

	if (align === 'center') {
		imageStyle.marginLeft = 'auto';
		imageStyle.marginRight = 'auto';
	} else if (align === 'right') {
		imageStyle.marginLeft = 'auto';
	}

	if (readerMode) {
		containerStyle.height = 0;
	}

	if (component.fixedwidth === 'on') {
		imageStyle.maxWidth = `${width}px`;
	}

	if (component.fullwidth === 'on') {
		imageStyle.maxWidth = `100vw`;
		delete imageStyle.width;
		// style.width = `100vw`;
	}

	let captionStyle = getStyle('imagecaption', style);
	if(captionStyle) {
		captionStyle.paddingTop = '2%';
		captionStyle.paddingBottom = '2%';
	}
	let creditStyle = getStyle('credit', style);

	let onClick = () => {};
	if (imagelink) {
		containerStyle.cursor = 'pointer';
		onClick = () => {
			if (linktype === 'page') {
				location.replace(imagelink);
				// location.replace(`/article/${pagelink}`);
			} else {
				window.open(imagelink);
			}
		};
	} else {
		if (onImageClick) {
			containerStyle.cursor = 'pointer';
			onClick = () => onImageClick(component);
		}
	}

	let captionComponent = null;
	let captionContent;
	if (captionenabled === 'on' && !!caption) {
		const lang = localStorage.getItem('language');

		if (typeof caption === 'string') {
			captionContent = { __html: caption };
			captionComponent = (
				<div
					style={captionStyle}
					className={styles['component-image-caption']}
					dangerouslySetInnerHTML={captionContent}
				/>
			);
		} else {
			if (caption[lang]) {
				captionContent = { __html: caption[lang] };
				captionComponent = (
					<div
						style={captionStyle}
						className={styles['component-image-caption']}
						dangerouslySetInnerHTML={captionContent}
					/>
				);

				caption = caption[lang];
			}
		}
	}

	let creditComponent = null;
	if (credit && creditenabled && creditenabled === 'on') {
		creditComponent = (
			<div
				style={creditStyle}
				className={styles['component-image-credit']}
				dangerouslySetInnerHTML={{ __html: credit }}
			/>
		);
	}

	if (component.bleed === 'on') {
		imageStyle.paddingLeft = 0;
		imageStyle.paddingRight = 0;
	}

	// Image clip
	switch (imageclip) {
		case 'circle':
			imageStyle.clipPath = 'circle(50% at 50% 50%)';
			break;
		case 'ellipse':
			imageStyle.clipPath = 'ellipse(25% 40% at 50% 50%)';
			break;
		case 'triangle':
			imageStyle.clipPath = 'polygon(50% 0%, 0% 100%, 100% 100%)';
			break;
		case 'trapezoid':
			imageStyle.clipPath = 'polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%)';
			break;
		case 'parallelogram':
			imageStyle.clipPath = 'polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%)';
			break;
		case 'rhombus':
			imageStyle.clipPath = 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)';
			break;
		case 'pentagon':
			imageStyle.clipPath =
				'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)';
			break;
		case 'hexagon':
			imageStyle.clipPath =
				'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)';
			break;
		case 'heptagon':
			imageStyle.clipPath =
				'polygon(50% 0%,90% 20%, 100% 60%,75% 100%, 25% 100%,0% 60%,10% 20%)';
			break;
		case 'octagon':
			imageStyle.clipPath =
				'polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)';
			break;
		case 'nonagon':
			imageStyle.clipPath =
				'polygon(50% 0%, 83% 12%, 100% 43%, 94% 78%, 68% 100%, 32% 100%, 6% 78%, 0% 43%, 17% 12%)';
			break;
		case 'decogon':
			imageStyle.clipPath =
				'polygon(50% 0%, 80% 10%, 100% 35%, 100% 70%, 80% 90%, 50% 100%, 20% 90%, 0% 70%, 0% 35%, 20% 10%)';
			break;
		case 'bevel':
			imageStyle.clipPath =
				'polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%)';
			break;
		case 'rabbet':
			imageStyle.clipPath =
				'polygon(0% 15%, 15% 15%, 15% 0%, 85% 0%, 85% 15%, 100% 15%, 100% 85%, 85% 85%, 85% 100%, 15% 100%, 15% 85%, 0% 85%)';
			break;
		case 'leftarrow':
			imageStyle.clipPath =
				'polygon(40% 0%, 40% 20%, 100% 20%, 100% 80%, 40% 80%, 40% 100%, 0% 50%)';
			break;
		case 'rightarrow':
			imageStyle.clipPath =
				'polygon(0% 20%, 60% 20%, 60% 0%, 100% 50%, 60% 100%, 60% 80%, 0% 80%)';
			break;
		case 'leftpoint':
			imageStyle.clipPath =
				'polygon(25% 0%, 100% 0%, 100% 100%, 25% 100%, 0% 50%)';
			break;
		case 'rightpoint':
			imageStyle.clipPath =
				'polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)';
			break;
		case 'rightchevron':
			imageStyle.clipPath =
				'polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%)';
			break;
		case 'leftchevron':
			imageStyle.clipPath =
				'polygon(100% 0%, 75% 50%, 100% 100%, 25% 100%, 0% 50%, 25% 0%)';
			break;
		case 'star':
			imageStyle.clipPath =
				'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)';
			break;
		case 'close':
			imageStyle.clipPath =
				'polygon(20% 0%, 0% 20%, 30% 50%, 0% 80%, 20% 100%, 50% 70%, 80% 100%, 100% 80%, 70% 50%, 100% 20%, 80% 0%, 50% 30%)';
			break;
	}

	return (
		<div
			id={id}
			className={styles['component-image']}
			style={containerStyle}
			onClick={onClick}
		>
			<LazyLoadImage
				src={`${imageurl.replace(/\\/g, '/')}`}
				width={deviceWidth}
				height={400}
				alt={caption}
				style={imageStyle}
			/>
			{captionComponent}
			{creditComponent}
		</div>
	);
}

ImageComponent.propTypes = {
	component: PropTypes.object.isRequired,
	readerMode: PropTypes.bool,
	deviceWidth: PropTypes.number,
	onImageClick: PropTypes.func,
	style: PropTypes.object,
	mediaStyle: PropTypes.object,
};
